<template>
  <div class="match-schedule">
    <div class="title">
      <span class="left">赛程列表</span>
    </div>
    <div class="turns">
      <div class="item" :class="num === current + 1 ? 'choose' : 'nope'" v-for="(num, index) in rounds.length" :key="index" @click="changeRounds(index)">
        第{{ index + 1 }}轮
      </div>
    </div>
    <div class="current" v-if="rounds && rounds.length > 0">第{{ current + 1 }}轮</div>
    <div v-if="rounds && rounds[current] && rounds[current].games">
      <div class="schedule" v-for="(item, index) in rounds[current].games" :key="index">
        <div class="number">
          NO.{{item.index}}
        </div>
        <div class="info">
          <div class="left">
            <div class="team">
              <div style="display: flex; flex-flow: row">
                <van-image width="20px" height="20px" :src="imgView(item.homeTeam.badge)" border-radius="4px"></van-image>
                <div class="name">{{item.homeTeam.name}}</div>
              </div>
              <div class="scoreInfo">{{item.homeScore >= 0 ? item.homeScore : '-'}}</div>
            </div>
            <div class="team" style="margin-top: 4px">
              <div style="display: flex; flex-flow: row">
                <van-image width="20px" height="20px" :src="imgView(item.awayTeam.badge)" border-radius="4px"></van-image>
                <div class="name">{{item.awayTeam.name}}</div>
              </div>
              <div class="scoreInfo">{{item.awayScore >= 0 ? item.awayScore : '-'}}</div>
            </div>
          </div>
          <div class="right">
            <div class="begin" v-if="item.beginDate">
              <div class="date">{{getDate(item.beginDate)}}</div>
              <div class="time">{{getTime(item.beginDate)}}</div>
            </div>
            <div class="begin" v-else>
              <div class="wait">待定</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage } from 'vant'
Vue.use(VanImage)
import {DateUtil, QNImageUtil} from "@/utils";
import {getBMMatchGameList} from "@/api/match";


export default {
  name: "MatchSchedule",
  props: {
    matchId: {}
  },
  data() {
    return {
      showTime: false,
      current: 0,
      rounds: [],
    }
  },
  mounted() {
    this.getBMMatchGameList()
  },
  methods: {
    imgView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getBMMatchGameList() {
      const params = {
        matchId: this.matchId
      }
      getBMMatchGameList(params).then(res => {
        if (res) {
          const { data } = res
          this.rounds = data.rounds
        }
      })
    },
    changeRounds(index) {
      this.current = index
    },
    getDate(time) {
      return !time ? '' : DateUtil.parseDateTime(time, '{m}-{d}')
    },
    getTime(time) {
      return !time ? '' : DateUtil.parseDateTime(time, '{h}:{i}')
    }
  }
}
</script>

<style lang="scss">
.match-schedule {
  background-color: #ffffff;
  width: 100%;
  border-radius: 8px;
  padding-bottom: 16px;
  .title {
    font-weight: 500;
    padding: 0;
    height: 51px;
    margin: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: #E5E5E5 0.5px solid;
    .left {
      font-size: 14px;
      color: #191919;
    }
  }
  .turns {
    padding: 20px 16px 16px 16px;
    white-space: nowrap;
    overflow: auto;
    .choose {
      background-color: #191919;
      color: #FFFFFF;
    }
    .nope {
      color: #282828;
      background-color: #F3F3F3;
    }
    .item {
      display: inline-block;
      width: 80px;
      height: 28px;
      line-height: 28px;
      margin-right: 11px;
      border-radius: 14px;
      text-align: center;
    }
  }
  .current {
    margin: 0 16px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-size: 14px;
    color: #474747;
    border-top: 0.5px #E5E5E5 solid;
    border-bottom: 0.5px #E5E5E5 solid;
  }
  .schedule {
    margin: 12px 16px 0 16px;
    background-color: #F9FAFC;
    border-radius: 8px;
    .number {
      height: 42px;
      padding-left: 16px;
      border-bottom: 1px #E5E5E5 solid;
      color: #191919;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
    }
    .info {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        width: calc(100% - 60px);
        padding: 0 12px;
        .team {
          color: #191919;
          font-size: 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .name {
            overflow: hidden;
            white-space: nowrap;
            margin-left: 6px;
          }
        }
      }
      .right {
        padding-left: 16px;
        width: 60px;
        border-left: 1px #E5E5E5 solid;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .begin {
          display: flex;
          flex-flow: column;
          justify-content: space-between;
          .date {
            font-size: 14px;
            color: #474747;
          }
          .time {
            font-size: 16px;
            font-weight: 500;
            color: #191919;
          }
          .wait {
            color: #191919;
            font-size: 12px;
            text-align: center;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
